import axios from 'axios';
import React, { useState, useEffect, useRef } from 'react';
import { BsEye, BsEyeSlash } from 'react-icons/bs';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import appConfig from '../../appConfig';
import { PasswordInput } from '../../components/Shared';
import { setActiveDashboard, setIsLogged, setUserDetails } from '../../redux/slices/user.slice';

const SignIn = () => {
  const [ErrorMessage, setErrorMessage] = useState();
  const [login, setLogin] = useState({
    email: '',
    password: '',
  });
  const { email, password } = login;
  const onInputChange = (e) => {
    setLogin({ ...login, [e.target.name]: e.target.value });
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const SubmitHandler = async (e) => {
    e.preventDefault();
    const response = await axios
      .post(`${process.env.REACT_APP_API_URL}/user/login`, login, { withCredentials: true })
      .catch(function (error) {
        if (error.response) {
          console.log(error);
          console.log(error.response.status);
          if (error.response.status === 401 || 500) {
            setErrorMessage('Credentials information wrong!');
            setTimeout(() => {
              setErrorMessage();
            }, 2000);
          }
          console.log(error.response.headers);
        }
      });
    console.log({ response });
    const data = response.data;
    if (data) {
      dispatch(setIsLogged(true));
      const userResponse = await axios.get(`${process.env.REACT_APP_API_URL}/user/me`, { withCredentials: true });
      if (userResponse) {
        console.log(userResponse.data);
        dispatch(setUserDetails(userResponse.data));
        dispatch(setActiveDashboard(userResponse.data.dashboard));
        navigate('/');
      }
    } else {
    }
  };
  useEffect(() => {
    document.title = `${appConfig.name} - SWITCHGEAR 2.0`;
  }, []);
  let background = '/img/bg.jpg';
  return (
    <div>
      <div className="az-content-wrapper p-0" style={{ backgroundImage: `url(${background})` }}>
        <div>
          <div className="az-signin-wrapper">
            <div className="az-card-signin">
              <h1 className="az-logo">
                <img src="/img/logo.png" alt="logo" style={{ width: 150 }} />
              </h1>
              <div className="az-signin-header">
                <h2>Welcome Back!</h2>
                <h4>Please sign in to continue</h4>
                {ErrorMessage && (
                  <div className="alert alert-danger" role="alert">
                    {ErrorMessage}{' '}
                  </div>
                )}
                <form onSubmit={SubmitHandler} >
                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <input
                      id="email"
                      type="email"
                      name="email"
                      value={email}
                      onChange={(e) => onInputChange(e)}
                      className="form-control"
                      placeholder="Enter your email"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="password">Password</label>
                    <div className="input-group">
                      <PasswordInput value={password} onChange={onInputChange} />
                    </div>
                    <p className="float-end text-muted">
                      <a href="/forgot-password">Forgot Password?</a>
                    </p>
                  </div>
                  <button type="submit" className="btn btn-az-primary btn-block">
                    Sign In
                  </button>
                </form>
              </div>
              <div className="az-signin-footer text-center mt-2">
                <p>Version 1.0 | {new Date().getFullYear()}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignIn;
